import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect } from "react";
import { myProjectService } from "../../../services/extensions";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { capitalize } from "../../../services/utility/helper";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setData } from "../../../services/store/userSlice";

const MyProject = () => {
    const dispatch = useDispatch();
    const [projectByUser, setProjectByUser] = useState([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Region: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        BU: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        title: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    });


    const [selectedProject, setSelectedProject] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchProjectsByUser();
    }, []);

    const fetchProjectsByUser = (data) => {
        myProjectService.getProjectsByUser(data).then(resp => {
            try {
                setProjectByUser(resp?.data?.data);
            } catch (error) {
                console.log(error);
            }
        });
    };

    const onGlobalFilterChange = (event) => {
        const value = event.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
    };

    const tableHeader = () => {
        const value = filters['global'] ? filters['global'].value : '';
        return (
            <div className="grid">
                <div className="col">
                    <h1 className="p-0 project_heading">My Project</h1>
                </div>
                <div className="col"></div>
                <div className="p-0" style={{ float: "right", marginTop: "14px" }}>
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText type="search" value={value || ''} onChange={(e) => onGlobalFilterChange(e)} placeholder="Search" />
                    </span>
                </div>
            </div>
        );
    };

    const regionTemplate = (data) => {
        return data?.customers?.legalEn?.code;
    };

    const buTemplate = (data) => {
        return data?.businessUnits?.title;
    };

    const clientTemplate = (data) => {
        return data?.customers?.title;
    };

    const projectTypeTemplate = (data) => {
        return data?.projectTypes?.title;
    };
    const ProjectManagerTemplate = (data) => {
        return capitalize(data?.pmDetails.firstName + " " + data?.pmDetails.lastName)

    };
    const startDateTemplate = (data) => {
        return data?.startDate;
    };
    const EndDateTemplate = (data) => {
        return data?.endDate;
    };

    const onCustomSaveState = (state) => {
        sessionStorage.setItem('dt-state-demo-custom', JSON.stringify(state));
    }
    const onCustomRestoreState = () => {
        return JSON.parse(sessionStorage.getItem('dt-state-demo-custom'));
    }

    const getProjectDetails = (e) => {
        dispatch(setData(e.value));
        setSelectedProject(e.value);
        navigate("/my-project-detail?projectId=" + e.value.id);
    }

    return (
        <div className="grid">
            <div className="col-12">
                <DataTable value={projectByUser} header={tableHeader} filters={filters} onFilter={(e) => setFilters(e.filters)}
                    emptyMessage="No Employee found." paginator paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]} editMode="row" stateStorage="custom" customSaveState={onCustomSaveState} customRestoreState={onCustomRestoreState} onSelectionChange={e => getProjectDetails(e)} selectionMode="single">
                    <Column field="code" header="Project ID" headerStyle={{ width: "3rem" }} sortable></Column>
                    <Column field="title" header="Project Name" headerStyle={{ width: "12rem" }} sortable
                    ></Column>
                    <Column field="" header="Client" body={clientTemplate} headerStyle={{ width: "8rem" }} sortable></Column>
                    <Column field="" header="Project Type" body={projectTypeTemplate} headerStyle={{ width: "8rem" }} sortable></Column>
                    <Column field="" header="Manager" body={ProjectManagerTemplate} headerStyle={{ width: "4rem" }} sortable></Column>
                    <Column field="" header="Start Date" body={startDateTemplate} headerStyle={{ width: "4rem" }} sortable></Column>
                    <Column field="" header="End Date" body={EndDateTemplate} headerStyle={{ width: "4rem" }} sortable></Column>
                </DataTable>
            </div>
        </div>
    );
};

export default MyProject;